export default {
  can_register: window.can_register,
  registrationMethod: 'login',
  is_connected: window.account !== undefined,

  registration: window.isEnvDevelopment ? {
    first_name: 'aa',
    last_name: 'aa',
    email: 'aa@gmail.fr',
    password: 'aaaaaaaa',
    password_confirmation: 'aaaaaaaa'
  } : {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password_confirmation: ''
  },

  login: window.isEnvDevelopment ? {
    email: 'user@gmail.com',
    password: 'useruser',
    remember: false
  } : {
    email: '',
    password: '',
    remember: false
  },

  registrationErrors: {}
}
